import styled from "styled-components";

import { typography } from "globalConstants";
import { Default } from "Types";
import { Atoms } from "Types/Components";

export type PropsType = Atoms.Label;

const Wrap = styled.div<Default>`
   ${typography.other.t7}
   overflow-wrap: break-word;
   word-break: keep-all;
   ${({ css }) => css}
`;

export default function AtomLabel(props: PropsType) {
   return <Wrap {...props}>{props.children}</Wrap>;
}
